import React from 'react'
import PropTypes from 'prop-types'
import { IconButton } from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'
import SydButton from '../../../../../../commonDesign/Button'
import EmptySection from '../../../../../../atoms/EmptySection'

function PurposeListSidebar ({
  purposes,
  selectedPurpose,
  onSelectPurpose,
  onAddPurpose,
  onRemovePurpose
}) {
  const purposeEntries = Object.entries(purposes || {})

  return (
    <div style={{
      borderRight: '1px solid var(--color-neutral-600)',
      paddingRight: '16px',
      minHeight: '400px'
    }}
    >
      <div style={{ marginBottom: '12px' }}>
        <SydButton
          variant='primary'
          size='sm'
          icon='add'
          onClick={onAddPurpose}
          style={{ width: '100%' }}
        >
          Add Purpose
        </SydButton>
      </div>

      {purposeEntries.length === 0 ? (
        <div style={{ paddingTop: '32px' }}>
          <EmptySection
            title='No Purposes'
            description='Click Add Purpose to get started'
            emptyDescription
          />
        </div>
      ) : (
        <div>
          {purposeEntries.map(([code, data]) => (
            <div
              key={code}
              onClick={() => onSelectPurpose(code)}
              style={{
                padding: '12px',
                marginBottom: '8px',
                borderRadius: '4px',
                cursor: 'pointer',
                color: selectedPurpose === code ? 'var(--color-contrast-primary-500)' : 'inherit',
                backgroundColor: selectedPurpose === code ? 'var(--color-primary-500)' : 'transparent',
                border: selectedPurpose === code ? '1px solid var(--color-primary-500)' : '1px solid #e0e0e0',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                transition: 'all 0.2s'
              }}
            >
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontWeight: 600, marginBottom: '2px' }}>{data.displayName}</div>
                <div style={{ fontSize: '0.75rem', color: 'var(--color-neutral-400)' }}>
                  {code}
                </div>
              </div>
              <IconButton
                size='small'
                onClick={(e) => {
                  e.stopPropagation()
                  onRemovePurpose(code)
                }}
              >
                <DeleteIcon fontSize='small' />
              </IconButton>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

PurposeListSidebar.propTypes = {
  purposes: PropTypes.object.isRequired,
  selectedPurpose: PropTypes.string,
  onSelectPurpose: PropTypes.func.isRequired,
  onAddPurpose: PropTypes.func.isRequired,
  onRemovePurpose: PropTypes.func.isRequired
}

export default PurposeListSidebar
